var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgD3Js(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: -201.009,
    y1: 376.844,
    x2: -200.098,
    y2: 375.873,
    gradientTransform: "matrix(82.4907 0 0 -81.4303 16634.416 30700.326)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a03c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7974e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M126.334 90.59a37.18 37.18 0 0 0 .128-1.647C126.5 88.288 87.094 50.9 87.094 50.9h-.942s39.94 42.13 40.182 39.69z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: -199.257,
    y1: 373.615,
    x2: -197.514,
    y2: 371.916,
    gradientTransform: "matrix(40.2105 0 0 -40.4122 8003.203 15127)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a03c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7974e"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M42.26 77.62a26.282 26.282 0 0 1-.328.702c-1.256 2.62 17.585 21.038 19.1 18.8.07-.098.14-.202.208-.3.077-.118.152-.23.228-.348 1.213-1.84-18.67-20.05-19.207-18.854z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: -199.836,
    y1: 374.252,
    x2: -198.286,
    y2: 372.475,
    gradientTransform: "matrix(41.0403 0 0 -39.9333 8224.5 14997.683)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a03c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7974e"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M68.886 103.52c-.053.118-.433.76-.78 1.098-.058.117 18.394 18.417 18.394 18.417h1.66c.002 0-17.32-18.74-19.274-19.514z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: -201.143,
    y1: 379.263,
    x2: -200.795,
    y2: 378.804,
    gradientTransform: "matrix(255.8347 0 0 -242.016 51476.605 91789.102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f26d58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a03c"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M126.488 88.61c-.863 19.13-16.69 34.425-36.024 34.425H87.85l-19.31-19.022a69.313 69.313 0 0 0 4.38-6.98h17.544c5.55 0 10.064-4.514 10.064-10.065 0-5.55-4.515-10.064-10.064-10.064H80.082A69.373 69.373 0 0 0 81.306 64c0-4.48-.44-8.852-1.26-13.1h6.45l39.88 39.295a48.62 48.62 0 0 0 .112-1.585zM11.962 4.772H1.472v26.003h10.49c18.32 0 33.23 14.903 33.23 33.225 0 4.984-1.113 9.716-3.088 13.964L61.24 96.82A58.882 58.882 0 0 0 71.2 64c0-32.658-26.574-59.228-59.236-59.228z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: -200.962,
    y1: 378.553,
    x2: -200.452,
    y2: 378.218,
    gradientTransform: "matrix(160.7307 0 0 -174.8133 32360.78 66184.883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b84e51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f68e48"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M90.464 4.772H47.986a69.81 69.81 0 0 1 24.82 26.003h17.658c5.55 0 10.064 4.513 10.064 10.064 0 5.55-4.515 10.06-10.064 10.06h-3.968l39.88 39.296a36.65 36.65 0 0 0 .152-3.228c0-8.766-3.146-16.807-8.368-23.066 5.223-6.256 8.368-14.3 8.368-23.063 0-19.887-16.177-36.068-36.064-36.068z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: -200.619,
    y1: 377.137,
    x2: -200.595,
    y2: 376.532,
    gradientTransform: "matrix(176.7653 0 0 -92.6293 35504.598 35022.56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a03c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7974e"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M87.85 123.035H48.29a69.95 69.95 0 0 0 20.25-19.022l19.31 19.022zM61.24 96.82L42.106 77.965c-5.287 11.362-16.807 19.264-30.143 19.264H1.472v26h10.49c20.53 0 38.648-10.5 49.28-26.407z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD3Js);
export default __webpack_public_path__ + "static/media/d3js.765b00482358a521369ca30cff3d11ea.svg";
export { ForwardRef as ReactComponent };